import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/icon-decline-white.svg'


const _hoisted_1 = { class: "eoi-details-header" }
const _hoisted_2 = { class: "breadcrumb-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "button-wrapper"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "spiner-wr"
}
const _hoisted_6 = {
  key: 1,
  class: "button-wrapper"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 2,
  class: "button-wrapper"
}
const _hoisted_10 = {
  key: 3,
  class: "button-wrapper"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 1,
  class: "spinner"
}
const _hoisted_15 = {
  key: 2,
  class: "eoi-details-wrapper"
}
const _hoisted_16 = { class: "card-column-first" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "card-eoi-details-row" }
const _hoisted_19 = { class: "eoi-row-value word-break" }
const _hoisted_20 = { class: "card-eoi-details-row" }
const _hoisted_21 = { class: "eoi-row-value" }
const _hoisted_22 = { class: "card-eoi-details-row" }
const _hoisted_23 = { class: "eoi-row-value word-break" }
const _hoisted_24 = { class: "card-eoi-details-row" }
const _hoisted_25 = { class: "eoi-row-value" }
const _hoisted_26 = { class: "card-eoi-details-row" }
const _hoisted_27 = { class: "eoi-row-value" }
const _hoisted_28 = { class: "card-eoi-details-row" }
const _hoisted_29 = { class: "eoi-row-value" }
const _hoisted_30 = { class: "card-eoi-details-row" }
const _hoisted_31 = { class: "eoi-row-value" }
const _hoisted_32 = { class: "card-eoi-details-row" }
const _hoisted_33 = { class: "eoi-row-value" }
const _hoisted_34 = { class: "card-eoi-details-row" }
const _hoisted_35 = { class: "eoi-row-value" }
const _hoisted_36 = { class: "card-eoi-details-row card-eoi-details-row--status" }
const _hoisted_37 = { class: "eoi-row-value" }
const _hoisted_38 = {
  key: 0,
  class: "card-eoi-details-row"
}
const _hoisted_39 = { class: "eoi-row-value" }
const _hoisted_40 = { class: "card" }
const _hoisted_41 = {
  key: 0,
  class: "card-wrapper"
}
const _hoisted_42 = { class: "card-eoi-details-row link-row" }
const _hoisted_43 = {
  key: 1,
  class: "text-info"
}
const _hoisted_44 = { class: "card-column-second" }
const _hoisted_45 = { class: "card" }
const _hoisted_46 = { class: "card-details-rows-wrapper card-details-rows-wrapper--company" }
const _hoisted_47 = { class: "card-eoi-details-row" }
const _hoisted_48 = { class: "eoi-row-value" }
const _hoisted_49 = { class: "card-eoi-details-row" }
const _hoisted_50 = { class: "eoi-row-value" }
const _hoisted_51 = { class: "card-eoi-details-row" }
const _hoisted_52 = { class: "eoi-row-value" }
const _hoisted_53 = { class: "card-eoi-details-row" }
const _hoisted_54 = { class: "eoi-row-value" }
const _hoisted_55 = { class: "card-eoi-details-row" }
const _hoisted_56 = { class: "eoi-row-value" }
const _hoisted_57 = { class: "card-eoi-details-row" }
const _hoisted_58 = { class: "eoi-row-value" }
const _hoisted_59 = { class: "card-title-bold" }
const _hoisted_60 = { class: "card-details-rows-wrapper card-details-rows-wrapper--buyer" }
const _hoisted_61 = { class: "card-eoi-details-row" }
const _hoisted_62 = { class: "eoi-row-value" }
const _hoisted_63 = { class: "card-eoi-details-row" }
const _hoisted_64 = { class: "eoi-row-value" }
const _hoisted_65 = { class: "card-eoi-details-row" }
const _hoisted_66 = { class: "eoi-row-value" }
const _hoisted_67 = { class: "card-eoi-details-row" }
const _hoisted_68 = { class: "eoi-row-value email" }
const _hoisted_69 = ["src"]
const _hoisted_70 = { class: "card-eoi-details-row" }
const _hoisted_71 = { class: "eoi-row-value" }
const _hoisted_72 = { class: "card-eoi-details-row" }
const _hoisted_73 = { class: "eoi-row-value" }
const _hoisted_74 = { class: "card-eoi-details-row" }
const _hoisted_75 = { class: "eoi-row-value" }
const _hoisted_76 = {
  key: 0,
  class: "card-eoi-details-row"
}
const _hoisted_77 = { class: "eoi-row-value" }
const _hoisted_78 = {
  key: 1,
  class: "card-eoi-details-row"
}
const _hoisted_79 = { class: "eoi-row-value" }
const _hoisted_80 = { key: 2 }
const _hoisted_81 = { class: "card-details-rows-wrapper card-details-rows-wrapper--buyer" }
const _hoisted_82 = {
  key: 0,
  class: "card-eoi-details-row"
}
const _hoisted_83 = { class: "eoi-row-value" }
const _hoisted_84 = {
  key: 1,
  class: "card-eoi-details-row"
}
const _hoisted_85 = { class: "eoi-row-value" }
const _hoisted_86 = { class: "card-title-bold" }
const _hoisted_87 = { class: "card-details-rows-wrapper card-details-rows-wrapper--buyer" }
const _hoisted_88 = {
  key: 0,
  class: "card-eoi-details-row"
}
const _hoisted_89 = { class: "eoi-row-value" }
const _hoisted_90 = {
  key: 1,
  class: "card-eoi-details-row"
}
const _hoisted_91 = { class: "eoi-row-value" }
const _hoisted_92 = {
  key: 2,
  class: "card-eoi-details-row"
}
const _hoisted_93 = { class: "eoi-row-value" }
const _hoisted_94 = {
  key: 3,
  class: "card-eoi-details-row"
}
const _hoisted_95 = { class: "eoi-row-value" }
const _hoisted_96 = {
  key: 4,
  class: "card-eoi-details-row"
}
const _hoisted_97 = { class: "eoi-row-value" }
const _hoisted_98 = {
  key: 5,
  class: "card-eoi-details-row"
}
const _hoisted_99 = { class: "eoi-row-value" }
const _hoisted_100 = {
  key: 6,
  class: "card-eoi-details-row"
}
const _hoisted_101 = { class: "eoi-row-value" }
const _hoisted_102 = {
  key: 7,
  class: "card-eoi-details-row"
}
const _hoisted_103 = { class: "eoi-row-value" }
const _hoisted_104 = {
  key: 8,
  class: "card-eoi-details-row"
}
const _hoisted_105 = { class: "eoi-row-value" }
const _hoisted_106 = {
  key: 2,
  class: "card-details-rows-wrapper card-details-rows-wrapper--buyer"
}
const _hoisted_107 = {
  key: 0,
  class: "card-title-small"
}
const _hoisted_108 = {
  key: 1,
  class: "card-eoi-details-row"
}
const _hoisted_109 = { class: "eoi-row-title" }
const _hoisted_110 = { class: "eoi-row-value" }
const _hoisted_111 = { key: 3 }
const _hoisted_112 = {
  key: 0,
  class: "card-details-rows-wrapper card-details-rows-wrapper--buyer"
}
const _hoisted_113 = {
  key: 0,
  class: "card-eoi-details-row"
}
const _hoisted_114 = { class: "eoi-row-value" }
const _hoisted_115 = {
  key: 1,
  class: "card-eoi-details-row"
}
const _hoisted_116 = { class: "eoi-row-value" }
const _hoisted_117 = {
  key: 2,
  class: "card-eoi-details-row"
}
const _hoisted_118 = { class: "eoi-row-value" }
const _hoisted_119 = {
  key: 3,
  class: "card-eoi-details-row"
}
const _hoisted_120 = { class: "eoi-row-value" }
const _hoisted_121 = {
  key: 4,
  class: "card-eoi-details-row"
}
const _hoisted_122 = { class: "eoi-row-value" }
const _hoisted_123 = {
  key: 5,
  class: "card-eoi-details-row"
}
const _hoisted_124 = { class: "eoi-row-value" }
const _hoisted_125 = {
  key: 6,
  class: "card-eoi-details-row"
}
const _hoisted_126 = { class: "eoi-row-value" }
const _hoisted_127 = {
  key: 7,
  class: "card-eoi-details-row"
}
const _hoisted_128 = { class: "eoi-row-value" }
const _hoisted_129 = {
  key: 1,
  class: "card-details-rows-wrapper card-details-rows-wrapper--contract"
}
const _hoisted_130 = {
  key: 0,
  class: "card-eoi-details-row"
}
const _hoisted_131 = { class: "eoi-row-value" }
const _hoisted_132 = {
  key: 1,
  class: "card-eoi-details-row"
}
const _hoisted_133 = { class: "eoi-row-value" }
const _hoisted_134 = {
  key: 2,
  class: "card-eoi-details-row"
}
const _hoisted_135 = { class: "eoi-row-value" }
const _hoisted_136 = {
  key: 3,
  class: "card-eoi-details-row"
}
const _hoisted_137 = { class: "eoi-row-value" }
const _hoisted_138 = {
  key: 4,
  class: "card-eoi-details-row"
}
const _hoisted_139 = { class: "eoi-row-value" }
const _hoisted_140 = {
  key: 5,
  class: "card-eoi-details-row"
}
const _hoisted_141 = { class: "eoi-row-value" }
const _hoisted_142 = {
  key: 6,
  class: "card-eoi-details-row"
}
const _hoisted_143 = { class: "eoi-row-value" }
const _hoisted_144 = {
  key: 7,
  class: "card-eoi-details-row"
}
const _hoisted_145 = { class: "eoi-row-value" }
const _hoisted_146 = {
  key: 8,
  class: "card-eoi-details-row"
}
const _hoisted_147 = { class: "eoi-row-value" }
const _hoisted_148 = {
  key: 9,
  class: "card-eoi-details-row"
}
const _hoisted_149 = { class: "eoi-row-value" }
const _hoisted_150 = {
  key: 2,
  class: "card-details-rows-wrapper card-details-rows-wrapper--contract"
}
const _hoisted_151 = { class: "card-eoi-details-row" }
const _hoisted_152 = { class: "eoi-row-value" }
const _hoisted_153 = { class: "card-eoi-details-row" }
const _hoisted_154 = { class: "eoi-row-value" }
const _hoisted_155 = { class: "card-eoi-details-row" }
const _hoisted_156 = { class: "eoi-row-value" }
const _hoisted_157 = { class: "card-eoi-details-row" }
const _hoisted_158 = { class: "eoi-row-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode($setup["Breadcrumbs"], {
          crumbs: $setup.crumbs,
          backButton: true,
          backButtonPath: $setup.backButtonPath
        }, null, 8, ["crumbs"]),
        ($setup.eoi?.status)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["badge badge--breadcrumbs", $setup.getEoiStatusClass($setup.eoi?.status as EoiStatus)])
            }, _toDisplayString($setup.getStatusText($setup.eoi?.status)), 3))
          : _createCommentVNode("", true)
      ]),
      ($setup.eoi && $setup.eoi.status === $setup.EoiStatus.PENDING && ($setup.canManageLot || $setup.isSameBusinessOwner))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!$setup.declineLoading)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["button button_decline", {'disabled-business-owner': !$setup.isSameBusinessOwner}]),
                  onClick: $setup.onButtonDecline,
                  disabled: !$setup.isSameBusinessOwner
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("div", { class: "content-button-wrapper" }, [
                    _createElementVNode("div", { class: "icon-button-wrapper" }, [
                      _createElementVNode("img", { src: _imports_0 })
                    ]),
                    _createTextVNode("Decline")
                  ], -1)
                ]))], 10, _hoisted_4))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("div", { class: "spinner spinner-small" }, null, -1)
                ]))])),
            (!$setup.deletedUser)
              ? (_openBlock(), _createBlock($setup["LotApproveButton"], {
                  key: 2,
                  lot: $setup.lotInfo,
                  onConfirm: $setup.onConfirm,
                  isPaymentAllowed: $setup.isPaymentAllowed,
                  isSameBusinessOwner: $setup.isSameBusinessOwner
                }, null, 8, ["lot", "isPaymentAllowed", "isSameBusinessOwner"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      ($setup.eoi && $setup.eoi.status === $setup.EoiStatus.WITHDRAWN && ($setup.canManageLot || $setup.isSameBusinessOwner))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "button button-refund-decline",
              onClick: $setup.refundDecline,
              disabled: !$setup.isSameBusinessOwner
            }, "Mark as non-refundable", 8, _hoisted_7),
            _createElementVNode("a", {
              class: "button primary button-refund-approve",
              onClick: $setup.onDepositeRefunded,
              disabled: !$setup.isSameBusinessOwner
            }, "Mark as deposit refunded", 8, _hoisted_8)
          ]))
        : _createCommentVNode("", true),
      ($setup.eoi && $setup.eoi.status === $setup.EoiStatus.TRANSACTION_ERROR && ($setup.canManageLot || $setup.isSameBusinessOwner))
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "button default copy",
              onClick: $setup.getPaymentUrl
            }, "Copy new payment link")
          ]))
        : _createCommentVNode("", true),
      ($setup.eoi && $setup.eoi.status === $setup.EoiStatus.APPROVED && ($setup.canManageLot || $setup.isSameBusinessOwner))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            ($setup.isDocusignEnabled)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button primary default generate-contract",
                  onClick: $setup.openSelectOptionToGenerateModal,
                  disabled: !$setup.isSameBusinessOwner
                }, "Generate Contract", 8, _hoisted_11))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "button primary default share",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openSendEoiDocumentsModal = true)),
              disabled: !$setup.isSameBusinessOwner
            }, "Share", 8, _hoisted_12),
            _createElementVNode("button", {
              class: "button primary default download-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.getSalesAdviceDocument())),
              disabled: $setup.downloadBtnLoading || !$setup.isSameBusinessOwner
            }, "Download", 8, _hoisted_13)
          ]))
        : _createCommentVNode("", true)
    ]),
    ($setup.deletedUser)
      ? (_openBlock(), _createBlock($setup["DeletedUserBlock"], { key: 0 }))
      : ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14))
        : ($setup.eoi)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[24] || (_cache[24] = _createElementVNode("h3", { class: "card-title-bold" }, "Lot Details", -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "eoi-row-title" }, "Lot No.", -1)),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_router_link, {
                        class: "link-with-hover",
                        to: `/lots/stage/${$setup.eoi.lotId.stageId._id}/lot/${$setup.eoi.lotId._id}/actions`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.eoi.lotId.title), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "eoi-row-title" }, "Street Name", -1)),
                    _createElementVNode("div", _hoisted_21, _toDisplayString($setup.eoi.lotId.streetName || '--'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "eoi-row-title" }, "Stage", -1)),
                    _createElementVNode("div", _hoisted_23, _toDisplayString($setup.eoi.lotId.stageId.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "eoi-row-title" }, "Block Width", -1)),
                    _createElementVNode("div", _hoisted_25, _toDisplayString($setup.zeroCheck($setup.formatPrice($setup.eoi.lotId.blockWidth, false), " m")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "eoi-row-title" }, "Block Depth", -1)),
                    _createElementVNode("div", _hoisted_27, _toDisplayString($setup.zeroCheck($setup.formatPrice($setup.eoi.lotId.blockDepth, false), " m")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "eoi-row-title" }, "Size", -1)),
                    _createElementVNode("div", _hoisted_29, _toDisplayString($setup.formatPrice($setup.eoi.lotId.size, false)) + " sqm", 1)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "eoi-row-title" }, "Release Date", -1)),
                    _createElementVNode("div", _hoisted_31, _toDisplayString($setup.eoi?.lotId?.releaseDate ? $setup.formatDate($setup.eoi.lotId.releaseDate) : "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "eoi-row-title" }, "Registration Date", -1)),
                    _createElementVNode("div", _hoisted_33, _toDisplayString($setup.eoi?.lotId?.registrationDate ? $setup.formatDate($setup.eoi.lotId.registrationDate, "MMM YYYY") : "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "eoi-row-title" }, "Price", -1)),
                    _createElementVNode("div", _hoisted_35, _toDisplayString($setup.formatPrice($setup.eoi.lotId.price)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "eoi-row-title" }, "Current Status", -1)),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["badge", $setup.getLotStatusClass(              $setup.eoi.lotId.status === $setup.LotStatus.EOI              ? $setup.LotStatus.PRE_CONTRACT              : $setup.eoi.lotId.status            )])
                      }, _toDisplayString($setup.eoi.lotId.status === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : $setup.eoi.lotId.status), 3)
                    ])
                  ]),
                  ($setup.eoi?.businessId?.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "eoi-row-title" }, "Business", -1)),
                        _createElementVNode("div", _hoisted_39, _toDisplayString($setup.eoi?.businessId?.name), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "card-title-bold" }, "Documents", -1)),
                  ($setup.documentsArray.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documentsArray, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            (item.link)
                              ? (_openBlock(), _createBlock($setup["DocumentItem"], {
                                  class: "block-documents--item",
                                  key: index,
                                  link: item.link,
                                  name: item.name
                                }, null, 8, ["link", "name"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_43, "No uploaded documents yet"))
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _cache[79] || (_cache[79] = _createElementVNode("h1", { class: "card-title" }, "Contract Information Form", -1)),
                  ($setup.isPurchasedByCompany)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[32] || (_cache[32] = _createElementVNode("h3", { class: "card-title-bold" }, "Company Details", -1)),
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "eoi-row-title" }, "Name", -1)),
                            _createElementVNode("div", _hoisted_48, _toDisplayString($setup.eoi.companyDetails?.name || "-"), 1)
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "eoi-row-title" }, "ABN / ACN", -1)),
                            _createElementVNode("div", _hoisted_50, _toDisplayString($setup.eoi.companyDetails?.businessIdentifier || "-"), 1)
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "eoi-row-title" }, "Address", -1)),
                            _createElementVNode("div", _hoisted_52, _toDisplayString($setup.eoi.companyDetails?.address || "-"), 1)
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "eoi-row-title" }, "Suburb", -1)),
                            _createElementVNode("div", _hoisted_54, _toDisplayString($setup.eoi.companyDetails?.suburb || "-"), 1)
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "eoi-row-title" }, "State", -1)),
                            _createElementVNode("div", _hoisted_56, _toDisplayString($setup.eoi.companyDetails?.state || "-"), 1)
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "eoi-row-title" }, "Postcode", -1)),
                            _createElementVNode("div", _hoisted_58, _toDisplayString($setup.eoi.companyDetails?.postcode), 1)
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("h3", _hoisted_59, _toDisplayString($setup.isPurchasedByCompany ? "Contact Person Details" : "Buyer Details"), 1),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _cache[33] || (_cache[33] = _createElementVNode("div", { class: "eoi-row-title" }, "First Name", -1)),
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_router_link, {
                          class: "link-with-hover",
                          to: `/contacts/${$setup.eoi?.customerId?._id}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.eoi.buyersData?.firstBuyer?.firstName), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "eoi-row-title" }, "Middle Name", -1)),
                      _createElementVNode("div", _hoisted_64, _toDisplayString($setup.eoi.buyersData?.firstBuyer?.middleName || "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "eoi-row-title" }, "Last Name", -1)),
                      _createElementVNode("div", _hoisted_66, _toDisplayString($setup.eoi.buyersData?.firstBuyer?.lastName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _cache[36] || (_cache[36] = _createElementVNode("div", { class: "eoi-row-title" }, "Email", -1)),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("span", null, _toDisplayString($setup.eoi.buyersData?.firstBuyer?.email), 1),
                        (!$setup.eoi?.customerId?.verifiedEmail)
                          ? _withDirectives((_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: require('@/assets/icons/icon-info.svg'),
                              alt: "info"
                            }, null, 8, _hoisted_69)), [
                              [_directive_tippy, { content: 'Email has not been verified yet.', theme: 'light-border', placement: 'top' }]
                            ])
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "eoi-row-title" }, "Phone Number", -1)),
                      _createElementVNode("div", _hoisted_71, _toDisplayString($setup.eoi.buyersData?.firstBuyer?.phone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "eoi-row-title" }, "Postcode", -1)),
                      _createElementVNode("div", _hoisted_73, _toDisplayString($setup.getFirstBuyerPostcode($setup.eoi.buyersData.firstBuyer.postcode, $setup.eoi.buyersData.firstBuyer.state) || "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _cache[39] || (_cache[39] = _createElementVNode("div", { class: "eoi-row-title" }, "Address", -1)),
                      _createElementVNode("div", _hoisted_75, _toDisplayString($setup.eoi.buyersData?.firstBuyer?.address), 1)
                    ]),
                    ($setup.eoi.buyersData?.firstBuyer?.suburb)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "eoi-row-title" }, "Suburb", -1)),
                          _createElementVNode("div", _hoisted_77, _toDisplayString($setup.eoi.buyersData?.firstBuyer?.suburb), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.eoi.buyersData?.firstBuyer?.state)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "eoi-row-title" }, "State", -1)),
                          _createElementVNode("div", _hoisted_79, _toDisplayString($setup.getFirstBuyerState($setup.eoi.buyersData.firstBuyer.state) || "-"), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.eoi.buyerType || $setup.eoi.agentReferrer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            ($setup.eoi.buyerType)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                  _cache[42] || (_cache[42] = _createElementVNode("div", { class: "eoi-row-title" }, "Buyer Type:", -1)),
                                  _createElementVNode("div", _hoisted_83, _toDisplayString($setup.eoi.buyerType), 1)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.eoi.agentReferrer)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                  _cache[43] || (_cache[43] = _createElementVNode("div", { class: "eoi-row-title" }, "Agent Referrer:", -1)),
                                  _createElementVNode("div", _hoisted_85, _toDisplayString($setup.eoi.agentReferrer), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  ($setup.eoi.buyersData.secondBuyer)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("h3", _hoisted_86, _toDisplayString($setup.isPurchasedByCompany ? "Contact Person Details 2" : "Buyer Details 2"), 1),
                        _createElementVNode("div", _hoisted_87, [
                          ($setup.eoi.buyersData.secondBuyer.firstName)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                _cache[44] || (_cache[44] = _createElementVNode("div", { class: "eoi-row-title" }, "First Name", -1)),
                                _createElementVNode("div", _hoisted_89, _toDisplayString($setup.eoi.buyersData.secondBuyer.firstName), 1)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.eoi.buyersData.secondBuyer.middleName)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                _cache[45] || (_cache[45] = _createElementVNode("div", { class: "eoi-row-title" }, "Middle Name", -1)),
                                _createElementVNode("div", _hoisted_91, _toDisplayString($setup.eoi.buyersData.secondBuyer.middleName), 1)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.eoi.buyersData.secondBuyer.lastName)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "eoi-row-title" }, "Last Name", -1)),
                                _createElementVNode("div", _hoisted_93, _toDisplayString($setup.eoi.buyersData.secondBuyer.lastName), 1)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.eoi.buyersData.secondBuyer.address)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "eoi-row-title" }, "Address", -1)),
                                _createElementVNode("div", _hoisted_95, _toDisplayString($setup.eoi.buyersData.secondBuyer.address), 1)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.eoi.buyersData.secondBuyer.postcode)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                _cache[48] || (_cache[48] = _createElementVNode("div", { class: "eoi-row-title" }, "Postcode", -1)),
                                _createElementVNode("div", _hoisted_97, _toDisplayString($setup.eoi.buyersData.secondBuyer.postcode), 1)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.eoi.buyersData.secondBuyer.suburb)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                _cache[49] || (_cache[49] = _createElementVNode("div", { class: "eoi-row-title" }, "Suburb", -1)),
                                _createElementVNode("div", _hoisted_99, _toDisplayString($setup.eoi.buyersData.secondBuyer.suburb), 1)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.eoi.buyersData.secondBuyer.state)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                _cache[50] || (_cache[50] = _createElementVNode("div", { class: "eoi-row-title" }, "State", -1)),
                                _createElementVNode("div", _hoisted_101, _toDisplayString($setup.eoi.buyersData.secondBuyer.state), 1)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.eoi.buyersData.secondBuyer.email)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                _cache[51] || (_cache[51] = _createElementVNode("div", { class: "eoi-row-title" }, "Email", -1)),
                                _createElementVNode("div", _hoisted_103, _toDisplayString($setup.eoi.buyersData.secondBuyer.email), 1)
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.eoi.buyersData.secondBuyer.phone)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                _cache[52] || (_cache[52] = _createElementVNode("div", { class: "eoi-row-title" }, "Phone Number", -1)),
                                _createElementVNode("div", _hoisted_105, _toDisplayString($setup.eoi.buyersData.secondBuyer.phone), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  ($setup.amlDisplayRows.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                        _cache[53] || (_cache[53] = _createElementVNode("h3", { class: "card-title-bold" }, "Identity & Source of Funds", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.amlDisplayRows, (row) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: `${row.heading || ''}-${row.label || ''}`
                          }, [
                            (row.heading)
                              ? (_openBlock(), _createElementBlock("h4", _hoisted_107, _toDisplayString(row.heading), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                  _createElementVNode("div", _hoisted_109, _toDisplayString(row.label), 1),
                                  _createElementVNode("div", _hoisted_110, _toDisplayString(row.value), 1)
                                ]))
                          ], 64))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.eoi.conveyancerDetails || $setup.eoi.contractConditions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                        ($setup.eoi.conveyancerDetails)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                              _cache[62] || (_cache[62] = _createElementVNode("h3", { class: "card-title-bold" }, "Conveyancer Details", -1)),
                              ($setup.eoi.conveyancerDetails.firmName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "eoi-row-title" }, "Firm Name:", -1)),
                                    _createElementVNode("div", _hoisted_114, _toDisplayString($setup.eoi.conveyancerDetails.firmName), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.conveyancerDetails.address)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "eoi-row-title" }, "Address:", -1)),
                                    _createElementVNode("div", _hoisted_116, _toDisplayString($setup.eoi.conveyancerDetails.address), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.conveyancerDetails.suburb)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                    _cache[56] || (_cache[56] = _createElementVNode("div", { class: "eoi-row-title" }, "Suburb:", -1)),
                                    _createElementVNode("div", _hoisted_118, _toDisplayString($setup.eoi.conveyancerDetails.suburb), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.conveyancerDetails.state)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                    _cache[57] || (_cache[57] = _createElementVNode("div", { class: "eoi-row-title" }, "State:", -1)),
                                    _createElementVNode("div", _hoisted_120, _toDisplayString($setup.eoi.conveyancerDetails.state), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.conveyancerDetails.postcode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                    _cache[58] || (_cache[58] = _createElementVNode("div", { class: "eoi-row-title" }, "Postcode:", -1)),
                                    _createElementVNode("div", _hoisted_122, _toDisplayString($setup.eoi.conveyancerDetails.postcode), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.conveyancerDetails.contactPerson.fullName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                    _cache[59] || (_cache[59] = _createElementVNode("div", { class: "eoi-row-title" }, "Contact Person:", -1)),
                                    _createElementVNode("div", _hoisted_124, _toDisplayString($setup.eoi.conveyancerDetails.contactPerson.fullName), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.conveyancerDetails.contactPerson.phone)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                    _cache[60] || (_cache[60] = _createElementVNode("div", { class: "eoi-row-title" }, "Phone Number:", -1)),
                                    _createElementVNode("div", _hoisted_126, _toDisplayString($setup.eoi.conveyancerDetails.contactPerson.phone), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.conveyancerDetails.contactPerson.email)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                    _cache[61] || (_cache[61] = _createElementVNode("div", { class: "eoi-row-title" }, "Email:", -1)),
                                    _createElementVNode("div", _hoisted_128, _toDisplayString($setup.eoi.conveyancerDetails.contactPerson.email), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        ($setup.eoi.contractConditions)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                              _cache[73] || (_cache[73] = _createElementVNode("h3", { class: "card-title-bold" }, " Contract Details:", -1)),
                              ($setup.getContractConditionsFields('subjectToFinance'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                    _cache[63] || (_cache[63] = _createElementVNode("div", { class: "eoi-row-title" }, "Will you be getting a loan for this purchase?", -1)),
                                    _createElementVNode("div", _hoisted_131, _toDisplayString($setup.eoi.contractConditions.subjectToFinance ? "Yes" : "No"), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.contractConditions.landLoanAmount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                    _cache[64] || (_cache[64] = _createElementVNode("div", { class: "eoi-row-title" }, "Land loan amount", -1)),
                                    _createElementVNode("div", _hoisted_133, _toDisplayString($setup.formatPrice($setup.eoi.contractConditions.landLoanAmount)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.contractConditions.financeStatus)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                                    _cache[65] || (_cache[65] = _createElementVNode("div", { class: "eoi-row-title" }, " Do you have finance pre-approval?", -1)),
                                    _createElementVNode("div", _hoisted_135, _toDisplayString($setup.eoi.contractConditions.financeStatus === $setup.EoiFinanceStatus.PRE_APPROVED ? "Yes" : "No"), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.getContractConditionsFields('FIRB'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                    _cache[66] || (_cache[66] = _createElementVNode("div", { class: "eoi-row-title" }, "Contract subject to FIRB?", -1)),
                                    _createElementVNode("div", _hoisted_137, _toDisplayString($setup.eoi.contractConditions.FIRB ? "Yes" : "No"), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.getContractConditionsFields('otherConditions'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                    _cache[67] || (_cache[67] = _createElementVNode("div", { class: "eoi-row-title" }, "Contract subject to any other conditions?", -1)),
                                    _createElementVNode("div", _hoisted_139, _toDisplayString($setup.eoi?.contractConditions?.otherConditions? $setup.eoi.contractConditions.otherConditions
: "No"), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.settlementDate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                    _cache[68] || (_cache[68] = _createElementVNode("div", { class: "eoi-row-title" }, "Settlement Date", -1)),
                                    _createElementVNode("div", _hoisted_141, _toDisplayString($setup.formatDate($setup.eoi.settlementDate)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.settlementDiscount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                    _cache[69] || (_cache[69] = _createElementVNode("div", { class: "eoi-row-title" }, "Settlement Discount", -1)),
                                    _createElementVNode("div", _hoisted_143, _toDisplayString($setup.formatPrice($setup.eoi.settlementDiscount)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.financeTerms)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                    _cache[70] || (_cache[70] = _createElementVNode("div", { class: "eoi-row-title" }, "Finance Terms", -1)),
                                    _createElementVNode("div", _hoisted_145, _toDisplayString($setup.eoi.financeTerms), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.eoi.contractPreparationFeeDate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                    _cache[71] || (_cache[71] = _createElementVNode("div", { class: "eoi-row-title" }, "Contract Preparation Fee Paid Date", -1)),
                                    _createElementVNode("div", _hoisted_147, _toDisplayString($setup.formatDate($setup.eoi.contractPreparationFeeDate)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (typeof($setup.eoi.isBuildContractRequired) === 'boolean')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                    _cache[72] || (_cache[72] = _createElementVNode("div", { class: "eoi-row-title" }, "Build contract required prior to settlement?", -1)),
                                    _createElementVNode("div", _hoisted_149, _toDisplayString($setup.eoi.isBuildContractRequired ? "Yes" : "No"), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        ($setup.eoi.contractConditions?.financeBrokerDetails)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                              _cache[78] || (_cache[78] = _createElementVNode("h3", { class: "card-title-bold" }, " Finance broker details", -1)),
                              _createElementVNode("div", _hoisted_151, [
                                _cache[74] || (_cache[74] = _createElementVNode("div", { class: "eoi-row-title" }, "Bank (Lending Institution)", -1)),
                                _createElementVNode("div", _hoisted_152, _toDisplayString($setup.eoi.contractConditions?.financeBrokerDetails?.lendingInstitution || "-"), 1)
                              ]),
                              _createElementVNode("div", _hoisted_153, [
                                _cache[75] || (_cache[75] = _createElementVNode("div", { class: "eoi-row-title" }, "Finance broker:", -1)),
                                _createElementVNode("div", _hoisted_154, _toDisplayString($setup.eoi.contractConditions?.financeBrokerDetails?.brokerName || "-"), 1)
                              ]),
                              _createElementVNode("div", _hoisted_155, [
                                _cache[76] || (_cache[76] = _createElementVNode("div", { class: "eoi-row-title" }, "Email:", -1)),
                                _createElementVNode("div", _hoisted_156, _toDisplayString($setup.eoi.contractConditions?.financeBrokerDetails?.email || "-"), 1)
                              ]),
                              _createElementVNode("div", _hoisted_157, [
                                _cache[77] || (_cache[77] = _createElementVNode("div", { class: "eoi-row-title" }, "Phone:", -1)),
                                _createElementVNode("div", _hoisted_158, _toDisplayString($setup.eoi.contractConditions?.financeBrokerDetails?.phone || "-"), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
    _createVNode($setup["SelectReiTemplate"], {
      isOpen: $setup.isSelectReiTemplateModalOpen,
      eoi: $setup.eoi,
      onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.isSelectReiTemplateModalOpen = false))
    }, null, 8, ["isOpen", "eoi"]),
    _createVNode($setup["SelectReiTemplate"], {
      isOpen: $setup.isSelectReiTemplateModalOpen,
      eoi: $setup.eoi,
      onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.isSelectReiTemplateModalOpen = false))
    }, null, 8, ["isOpen", "eoi"]),
    _createVNode($setup["LotDeclineModal"], {
      isOpen: $setup.isOpenDeclineModal,
      eoiId: $setup.lotInfo?.eoiId,
      lotTitle: $setup.lotInfo?.lot,
      moneyHoldId: $setup.eoi?.moneyHoldId,
      onClose: $setup.onCloseDeclineModal,
      onConfirm: $setup.onDecline,
      onLoading: $setup.onDeclineLoading
    }, null, 8, ["isOpen", "eoiId", "lotTitle", "moneyHoldId"]),
    _createVNode($setup["EoiDeclineRefundModal"], {
      "is-open": $setup.isEoiDeclineRefundModal,
      eoiId: $setup.eoiId,
      onClose: $setup.onCloseRefundDeclineModal,
      onConfirm: $setup.onRefundDeclineModal
    }, null, 8, ["is-open", "eoiId"]),
    _createVNode($setup["AttentionModal"], {
      isOpen: $setup.showAttentionModal,
      title: "Attention",
      description: "Payments are temporarily unavailable. Please try again later.",
      onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.showAttentionModal = false))
    }, null, 8, ["isOpen"]),
    ($setup.openCompletedResForm)
      ? (_openBlock(), _createBlock($setup["CompletedResForm"], {
          key: 3,
          "is-open": $setup.openCompletedResForm,
          onClose: $setup.closeCompletedResForm,
          onShare: _cache[5] || (_cache[5] = ($event: any) => ($setup.openSendEoiDocumentsModal = true)),
          eoiId: $setup.eoiId,
          isDocusignEnabled: $setup.isDocusignEnabled,
          onGenerate: $setup.openSelectOptionToGenerateModal
        }, null, 8, ["is-open", "eoiId", "isDocusignEnabled"]))
      : _createCommentVNode("", true),
    ($setup.openSendEoiDocumentsModal)
      ? (_openBlock(), _createBlock($setup["SendEoiDocumentsModal"], {
          key: 4,
          "is-open": $setup.openSendEoiDocumentsModal,
          onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.openSendEoiDocumentsModal = false)),
          eoiId: $setup.eoiId
        }, null, 8, ["is-open", "eoiId"]))
      : _createCommentVNode("", true),
    _createVNode($setup["SuccessDocusignModal"], {
      isOpen: $setup.isSuccessModalOpen,
      onClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.isSuccessModalOpen = false))
    }, null, 8, ["isOpen"]),
    ($setup.eoi && $setup.isDocusignFieldsModalOpen && $setup.store.state.docusign.userData.isLogged)
      ? (_openBlock(), _createBlock($setup["GenerateContractFieldsModal"], {
          key: 5,
          isOpen: $setup.isDocusignFieldsModalOpen,
          eoi: $setup.eoi,
          onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.isDocusignFieldsModalOpen = false)),
          onSuccess: _cache[9] || (_cache[9] = ($event: any) => ($setup.isSuccessModalOpen = true))
        }, null, 8, ["isOpen", "eoi"]))
      : _createCommentVNode("", true),
    _createVNode($setup["SelectOptionToGenerateContractModal"], {
      isOpen: $setup.isSelectOptionToGenerateContractModal,
      onClose: _cache[10] || (_cache[10] = ($event: any) => ($setup.isSelectOptionToGenerateContractModal = false)),
      onGenerateContract: $setup.onGenerateContract
    }, null, 8, ["isOpen"])
  ], 64))
}